module.exports = __webpack_public_path__ + "static/media/Table_Games@3x.aeeb500a.png";